// La Candela: en la descripción del producto, convierte las secciones con título en negrita
// ("Por qué te va a gustar", "Perfecta para", "Detalles", "Descripciones por aroma")
// en menús desplegables con el mismo estilo de las pestañas del tema.
// No modifica la descripción guardada en Shopify: solo cómo se muestra.
(function () {
  var TITULOS = ['por qué te va a gustar', 'perfecta para', 'detalles', 'descripciones por aroma'];

  function textoDe(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Un párrafo cuyo único contenido es un texto en negrita.
  function esTituloNegrita(el) {
    if (!el || el.tagName !== 'P') return false;
    var strong = el.querySelector('strong, b');
    return !!strong && textoDe(strong) === textoDe(el) && textoDe(el).length > 0 && !el.querySelector('em, i');
  }

  function esTituloDesplegable(el) {
    if (!esTituloNegrita(el)) return false;
    var t = textoDe(el).toLowerCase().replace(/:$/, '');
    return TITULOS.indexOf(t) !== -1;
  }

  // Contenido que pertenece a la sección: listas y párrafos normales.
  // Se detiene en otro título, en citas o textos en cursiva, y en separadores.
  function esContenido(el) {
    if (!el) return false;
    if (el.tagName === 'UL' || el.tagName === 'OL') return true;
    if (el.tagName !== 'P') return false;
    if (esTituloNegrita(el)) return false;
    if (el.querySelector('em, i')) return false;
    return textoDe(el).length > 0;
  }

  function crearDesplegable(titulo, nodos, caret) {
    var wrap = document.createElement('div');
    wrap.className = 'product__accordion accordion lc-acordeon';
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    var head = document.createElement('div');
    head.className = 'summary__title';
    var h = document.createElement('h2');
    h.className = 'h4 accordion__title';
    h.textContent = titulo;
    head.appendChild(h);
    summary.appendChild(head);
    if (caret) summary.appendChild(caret.cloneNode(true));
    var content = document.createElement('div');
    content.className = 'accordion__content rte';
    nodos.forEach(function (n) {
      content.appendChild(n);
    });
    details.appendChild(summary);
    details.appendChild(content);
    wrap.appendChild(details);
    return wrap;
  }

  function aplicar() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.lcAcordeon) return;
    desc.dataset.lcAcordeon = '1';
    // La flecha (caret) de las pestañas del tema: hija directa de <summary>.
    var caret = document.querySelector('.product__accordion summary > svg.icon-caret');

    var titulos = Array.prototype.filter.call(desc.querySelectorAll('p'), esTituloDesplegable);
    titulos.forEach(function (p) {
      var nodos = [];
      var sig = p.nextElementSibling;
      while (sig && esContenido(sig)) {
        var siguiente = sig.nextElementSibling;
        nodos.push(sig);
        sig = siguiente;
      }
      if (!nodos.length) {
        p.remove();
        return;
      }
      var titulo = textoDe(p).replace(/:$/, '');
      p.replaceWith(crearDesplegable(titulo, nodos, caret));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aplicar);
  } else {
    aplicar();
  }
})();
